import React, { KeyboardEvent, useState } from 'react';
import _get from 'lodash/get';
import _startCase from 'lodash/startCase';

import { getTailwindColor } from '@trqk/utils';

const disabledColor = getTailwindColor('tertiary-100');

export const EarningsLegendItem = ({
    columnSeries,
    legendValue,
}: EarningsLegendSource): JSX.Element => {
    const { name } = columnSeries;
    const [isDisabled, setIsDisabled] = useState(columnSeries.isHidden);
    const activeColor = _get(columnSeries, ['fill', 'hex']);
    const color = isDisabled ? disabledColor : activeColor;
    const handleClickOrEnterKey = (): void => {
        if (isDisabled) {
            columnSeries.show();
            setIsDisabled(false);
        } else {
            columnSeries.hide();
            setIsDisabled(true);
        }
    };

    return (
        <div className="flex-none flex" key={`legend-item-${name}`}>
            <button
                className="cursor-pointer"
                type="button"
                onClick={handleClickOrEnterKey}
                onKeyDown={(e: KeyboardEvent): void => {
                    if (e.key === 'Enter') {
                        handleClickOrEnterKey();
                    }
                }}
            >
                <div className="text-left flex-none flex mx-3">
                    <div
                        className="legend-marker inline-block border border-solid border-tertiary-300 mt-1 mr-3 w-4 h-4 rounded flex-none"
                        style={{ backgroundColor: color }}
                    />
                    <div>
                        <span className="font-bold">{_startCase(name)}</span>
                        {`: ${legendValue}`}
                    </div>
                </div>
            </button>
        </div>
    );
};
